import get from 'lodash/get';
import {
  NOT_CORRECT_EXAM_FORM_SHOW,
  NOT_CORRECT_EXAM_FORM_HIDE,
  NOT_CORRECT_EXAM_FORM_CHANGE,
  NOT_CORRECT_EXAM_FORM_SUBMIT_SUCCESS,
  NOT_CORRECT_EXAM_FORM_SUBMIT_ERROR,
  NOT_CORRECT_EXAM_FORM_SET_INVALID,
  NOT_CORRECT_EXAM_FORM_SUBMIT,
  SET_MAIN_DATA,
  CHANGE_MAIN_DATA,
  REQUEST_APPEAL_ALREADY_REPORTED,
} from '../constants';

const initialState = {
  visibleForm: false,
  requestSuccess: null,
  examName: null,
  form: {
    valid: true,
    email: {
      value: '',
      valid: true,
      message: '',
    },
    phone: {
      value: '',
      valid: true,
      message: '',
    },
    comment: {
      value: '',
      valid: true,
      message: '',
    },
  },
};

const FIELDS = {
  email: 'payload.data.email',
  phone: 'payload.data.phone',
  comment: 'payload.data.comment',
};

const notCorrectExam = (state = initialState, action) => {
  switch (action.type) {
    case NOT_CORRECT_EXAM_FORM_SHOW:
      return {
        ...state,
        visibleForm: true,
        examName: action.payload,
      };
    case NOT_CORRECT_EXAM_FORM_HIDE:
      return {
        ...state,
        visibleForm: false,
        requestSuccess: null,
        examName: null,
      };
    case NOT_CORRECT_EXAM_FORM_SUBMIT_ERROR:
    case REQUEST_APPEAL_ALREADY_REPORTED:
      return {
        ...initialState,
      };
    case SET_MAIN_DATA:
      return {
        ...state,
        form: {
          valid: true,
          email: {
            value: get(action, FIELDS.email)
              ? get(action, FIELDS.email)
              : state.form.email.value,
            valid: true,
            message: null,
          },
          phone: {
            value: get(action, FIELDS.phone)
              ? get(action, FIELDS.phone)
              : state.form.phone.value,
            valid: true,
            message: null,
          },
          comment: {
            value: get(action, FIELDS.comment)
              ? get(action, FIELDS.comment)
              : state.form.comment.value,
            valid: true,
            message: null,
          },
        },
      };
    case CHANGE_MAIN_DATA:
      return {
        ...state,
        form: {
          valid: true,
          email: {
            value: get(action, FIELDS.email)
              ? get(action, FIELDS.email)
              : state.form.email.value,
            valid: true,
            message: null,
          },
          phone: {
            value: get(action, FIELDS.phone)
              ? get(action, FIELDS.phone)
              : state.form.phone.value,
            valid: true,
            message: null,
          },
          comment: { ...state.form.comment },
        },
      };
    case NOT_CORRECT_EXAM_FORM_CHANGE:
      return {
        ...state,
        form: {
          ...state.form,
          loading: false,
          valid: true,
          [action.payload.field]: {
            value: action.payload.value,
            valid: action.payload.valid,
            message: action.payload.message,
          },
        },
      };
    case NOT_CORRECT_EXAM_FORM_SET_INVALID:
      return {
        ...state,
        loading: false,
        form: {
          ...state.form,
          ...action.payload,
        },
      };
    case NOT_CORRECT_EXAM_FORM_SUBMIT:
      return {
        ...state,
        loading: true,
      };
    case NOT_CORRECT_EXAM_FORM_SUBMIT_SUCCESS:
      return {
        ...state,
        loading: false,
        visibleForm: false,
        examName: null,
        requestSuccess: action.payload,
      };
    default:
      return state;
  }
};

export default notCorrectExam;
